import { SVGProps, Ref, forwardRef } from 'react';

export const CheckCircleFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 .5C1.875.5.5 3.25.5 6s1.375 5.5 5.5 5.5 5.5-2.75 5.5-5.5S10.125.5 6 .5m2.886 4-.636-.636-3 3-1.5-1.5L3.114 6 5.25 8.136z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CheckCircleFilledSize12Glyph.displayName = 'CheckCircleFilledSize12Glyph';
